import { DesktopQuantFolio, MobileQuantFolio, TabletQuantFolio } from ".";
import { withAdaptiveRender } from "../utils/hoc/withAdaptiveRender";

export const AdaptedQuantFolio = withAdaptiveRender({
  desktop: DesktopQuantFolio,
  tablet: TabletQuantFolio,
  mobile: MobileQuantFolio,
});
